import { Component, OnInit } from '@angular/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-data-collector-information',
  templateUrl: './data-collector-information.component.html',
  styleUrls: ['./data-collector-information.component.scss']
})
export class DataCollectorInformationComponent implements OnInit {

  dummySessionDetails:any;
  vinNumber: string = '';
  userId: string = '';
  userName: string = '';
  userType: string = '';
  showSessionTable:string = '';
  fdspToken: any;
  languageCode: any;

  constructor(public service: ApifirstService,private spinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
    this.service.tokenObj.subscribe((data:any)=> {
      this.vinNumber = data.vin;
      this.userName = data.username;
      this.userType = data.userType;
      this.languageCode = data.language;
      console.log('Token OBJ', data);
    })

    this.service.loginUserId.subscribe((data: any)=> {
      this.userId = data;
    })

    this.service.rapToken.subscribe((data) => {
      this.fdspToken = data;
    })

    this.getDummySessionDetails();
   
  }

  getDummySessionDetails() {

    let req = {
      "vin":this.vinNumber,
      "userid":this.userId,
      "lastworkflowstate":"null"
    }
    this.spinnerService.show();
    this.service.getDummySessionDetails(req).subscribe((data:any)=> {
      if(data.length == 0) {
        this.showSessionTable = 'false';
      } else {
        this.showSessionTable = 'true';
      }
      this.dummySessionDetails = data;
      this.spinnerService.hide();
      console.log('Dummy Session Details:', data);
    })
  }

  viewDataCollectorInfo(timestamp: any, vin: any) {
   console.log('Time stamp ===========', timestamp);
    const path = '/viewDataCollectorInfo' + "?vin=" + vin + "&timestamp=" + timestamp + "&userName="+ this.userName + "&userType=" + this.userType + "&language=" + this.languageCode + "&token=" + this.fdspToken + "#nohref";
    window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
  }

}
